export default __webpack_public_path__ + "static/media/administrator1.ffba6ad1.png";